define('lq/events/actions/createTextFileCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function CreateTextFileCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(CreateTextFileCommand, EventAction);

    CreateTextFileCommand.typeName = 'CreateTextFileCommand';

    CreateTextFileCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    CreateTextFileCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'CreateTextFile',
            command: this.eventData.command
        };
    };

    CreateTextFileCommand.prototype.execute = function (continuation, eventActionResponse) {
        continuation();
    };

    CreateTextFileCommand.prototype.handleError = function (eventName, defaultMessage, continuation) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    return CreateTextFileCommand;
});
